import { flat, map, pipe, toArray } from '@fxts/core';
import { MpMakerTypeTotalCvObj } from '@modules/NewMaker/Type/S/Constant';

export const getFlattenCvDesigns = (cv_objs: MpMakerTypeTotalCvObj[]): MpMakerTypeTotalCvObj[] => {
  return pipe(
    cv_objs,
    map((cv_obj) => {
      if (!('objects' in cv_obj) && !('_objects' in cv_obj)) return cv_obj;
      const objects = cv_obj?.objects || cv_obj?._objects;

      if (objects === undefined || objects.length === 0) {
        return cv_obj;
      } else {
        return getFlattenCvDesigns(objects);
      }
    }),
    flat,
    toArray,
  );
};
